import React from "react";

import { Badge as AntBadge, BadgeProps as AntBadgeProps } from "antd";

type BadgeProps = AntBadgeProps & {
  dataTestId?: string;
};

export const Badge = ({ className, children, dataTestId, ...props }: BadgeProps) => (
  <AntBadge data-testid={dataTestId} className={`${className} verified`} {...props}>
    {children}
  </AntBadge>
);
